'use client';
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { createBrowserClient } from '@supabase/ssr';
import { ApertureLogo } from '@/components/arku/aperture-logo';

export default function LoginPage() {
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const supabase = createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
    );
    const { error: signInErr, data } = await supabase.auth.signInWithPassword({ email, password });
    if (signInErr) {
      setError(signInErr.message);
      setLoading(false);
      return;
    }
    // Determine destination based on user roles
    const userId = data.user.id;
    const { data: roles } = await supabase
      .from('user_tenant_roles')
      .select('tenant_id, role, tenants(slug)')
      .eq('user_id', userId);

    const isSuperAdmin = roles?.some(r => r.tenant_id === '00000000-0000-0000-0000-000000000000' && r.role === 'super_admin');
    if (isSuperAdmin) {
      router.push('/admin/tenants');
      return;
    }
    const tenantSlug = (roles?.[0] as { tenants?: { slug?: string } })?.tenants?.slug;
    router.push(tenantSlug ? `/${tenantSlug}/cockpit` : '/');
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ background: 'var(--bg, #F4F3EE)' }}
    >
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <ApertureLogo size={36} />
          <div
            className="mono mt-3"
            style={{
              fontSize: 18,
              fontWeight: 600,
              letterSpacing: '.24em',
              textTransform: 'uppercase',
              color: 'var(--ink, #0E0F12)',
            }}
          >
            ARKU
          </div>
          <div className="text-xs mt-1" style={{ color: 'var(--muted, #5C5E64)' }}>
            platform for AEC
          </div>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-md border border-neutral-200 p-6 space-y-4">
          <div>
            <label className="block text-xs font-medium text-neutral-700 uppercase tracking-wide mb-1">Email</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus
              className="w-full px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-900"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-neutral-700 uppercase tracking-wide mb-1">Password</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)} required
              className="w-full px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-900"
            />
          </div>
          {error && <div className="text-xs text-rose-600 bg-rose-50 px-3 py-2 rounded-md">{error}</div>}
          <button
            type="submit" disabled={loading}
            className="w-full px-4 py-2 bg-neutral-900 text-white text-sm rounded-md hover:bg-neutral-800 disabled:opacity-50"
          >
            {loading ? 'Entrando…' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
